import { Component, OnInit, Renderer2 } from '@angular/core';
import { ServiceService } from '../services/service.service';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { FileSaver } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import iziToast from 'izitoast';

@Component({
  selector: 'app-invoice-history',
  templateUrl: './invoice-history.component.html',
  styleUrls: ['./invoice-history.component.css']
})
export class InvoiceHistoryComponent implements OnInit {

  user_id: any;
  page2 = 1;
  pageSize = 10;
  invoice_list: any[] = [];

  private overlay: HTMLElement | null = null;

  // download invoice 

  isDownloading = false;
  pdfUrlBlob: any;

  pdfUrl: SafeResourceUrl | null = null;
  isViewing: boolean = false;
  showPdfModal: boolean = false;
  rawBlobUrl: string | null = null;

  constructor(private serviceService: ServiceService, private router: Router, private http: HttpClient,
    private sanitizer: DomSanitizer, private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    this.user_id = localStorage.getItem('user_name');
    this.invoice_history_list()
  }

  loaderStart() {
    // Create overlay and loader only when API is called
    this.overlay = this.renderer.createElement('div');
    const loader = this.renderer.createElement('div');

    this.renderer.addClass(this.overlay, 'overlay');
    this.renderer.addClass(loader, 'loader');

    loader.innerHTML = 'Loading...'; // Optional text

    this.renderer.appendChild(this.overlay, loader);
    this.renderer.appendChild(document.body, this.overlay);
  }

  loaderEnd() {
    this.renderer.removeChild(document.body, this.overlay);
  }

  invoice_history_list() {

    this.loaderStart();
    const api_req: any = {
      action: "list_invoice",
      // phone_number: '7200892218',
      phone_number: this.user_id,
    };

    this.serviceService.sendzohoServer(api_req).subscribe((response: any) => {
      if (response.success == true || response.success == 'true') {
        this.invoice_list = response.data;
        this.loaderEnd();
      } else {
        console.error('Failed to load invoice data.');
        this.loaderEnd();
      }
    });
  }


  downloadBlobPDF(invoiceID: any, invoiceNumber: any) {
    const api_req: any = {
      action: "download_invoice",
      invoice_id: invoiceID,
      invoice_number: invoiceNumber,
    };

    this.isDownloading = true;

    this.serviceService.sendzohoServer(api_req).subscribe({
      next: (response: any) => {
        if (response.success === true || response.success === 'true') {
          const pdfUrl = response.data;

          // download pdf file 

          this.http.get(pdfUrl, { responseType: 'arraybuffer' }).subscribe({
            next: (pdfData) => {
              const blob = new Blob([pdfData], { type: 'application/pdf' });
              const downloadLink = document.createElement('a');
              const fileName = `Invoice_${invoiceNumber}.pdf`;

              downloadLink.href = window.URL.createObjectURL(blob);
              downloadLink.download = fileName;
              downloadLink.target = '_blank';
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);

              this.isDownloading = false;
            },
            error: (err) => {
              console.error('PDF download failed:', err);
              iziToast.error({
                message: 'Failed to download PDF.',
                position: 'topRight'
              });
              this.isDownloading = false;
            }
          });

        } else {
          iziToast.error({
            message: 'Invoice not found.',
            position: 'topRight'
          });
          this.isDownloading = false;
        }
      },
      error: (err) => {
        console.error('API error:', err);
        iziToast.error({
          message: 'Server error while requesting invoice.',
          position: 'topRight'
        });
        this.isDownloading = false;
      }
    });
  }

  viewBlobPDF(invoiceID: any, invoiceNumber: any) {
    const api_req: any = {
      action: "download_invoice",
      invoice_id: invoiceID,
      invoice_number: invoiceNumber,
    };

    this.isDownloading = true;

    this.serviceService.sendzohoServer(api_req).subscribe({
      next: (response: any) => {
        if (response.success === true || response.success === 'true') {
          const pdfUrl = response.data;

          this.http.get(pdfUrl, { responseType: 'arraybuffer' }).subscribe({
            next: (pdfData) => {
              const blob = new Blob([pdfData], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              window.open(blobUrl, '_blank');

              this.isDownloading = false;
            },
            error: (err) => {
              console.error('PDF view failed:', err);
              iziToast.error({
                message: 'Failed to view PDF.',
                position: 'topRight'
              });
              this.isDownloading = false;
            }
          });

        } else {
          iziToast.error({
            message: 'Invoice not found.',
            position: 'topRight'
          });
          this.isDownloading = false;
        }
      },
      error: (err) => {
        console.error('API error:', err);
        iziToast.error({
          message: 'Server error while requesting invoice.',
          position: 'topRight'
        });
        this.isDownloading = false;
      }
    });
  }

  downloadInvoice(invoiceId: string, invoiceNumber: string) {
    this.loaderStart();
    fetch('https://chettinadlink.com/zoho-apis/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        action: 'download_invoice',
        invoice_id: invoiceId,
        invoice_number: invoiceNumber
      })
    })
      .then(response => {
        if (!response.ok) {
          this.loaderEnd();
          throw new Error("Failed to download invoice");
        }
        return response.blob();
      })
      .then(blob => {
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `invoice_${invoiceNumber}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(downloadUrl);
        this.loaderEnd();
      })
      .catch(err => {
        alert("Error: " + err.message);
        console.error("Download error:", err);
        this.loaderEnd();
      });
  }



  viewInvoice(invoiceId: number, invoiceNumber: string): void {

    this.loaderStart();
    this.isViewing = true;
    this.pdfUrl = null;

    fetch('https://chettinadlink.com/zoho-apis/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        action: 'download_invoice',
        invoice_id: invoiceId,
        invoice_number: invoiceNumber
      })
    })
      .then(response => {
        if (!response.ok) throw new Error("Failed to fetch invoice");
        return response.blob();
      })
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob);
        this.rawBlobUrl = blobUrl;
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
        this.showPdfModal = true;
        this.loaderEnd();
      })
      .catch(err => {
        alert("Error: " + err.message);
        console.error("View error:", err);
        this.loaderEnd();
      })
      .finally(() => {
        this.isViewing = false;
        this.loaderEnd();
      });

  }

  closePdfModal(): void {
    this.showPdfModal = false;
    if (this.rawBlobUrl) {
      URL.revokeObjectURL(this.rawBlobUrl);
      this.rawBlobUrl = null;
    }

    this.pdfUrl = null;
  }







}
